import { FilterModel } from "../filter.model";

export class DtReportModel {

  reportUid: number;
  reportName: string;
  reportDescription: string;
  reportPeriod: string;
  startDateTime: string;
  endDateTime: string;
  organisationUid: number;
  organisationName: string;
  organisationSelect: FilterModel;
  clientUid: number;
  readableDate: string;

  constructor() {
  }
}